$(document).on( 'scroll', function() {
    let distanceScrolled =  $(document).scrollTop();

    $('.parallax-background__elem').each( function() {
        let scrollSpeed = $(this).data('scroll-speed');

        if ( typeof scrollSpeed === 'undefined' ) {
            scrollSpeed = 0.25;
        }

        $(this).css({'transform': 'translate3d(0, '+ (distanceScrolled * scrollSpeed) +'px, 0)' });
    });
});